import { render, staticRenderFns } from "./RelevanceTopicModal.vue?vue&type=template&id=745a3cf7&scoped=true&"
import script from "./RelevanceTopicModal.vue?vue&type=script&lang=js&"
export * from "./RelevanceTopicModal.vue?vue&type=script&lang=js&"
import style0 from "./RelevanceTopicModal.vue?vue&type=style&index=0&id=745a3cf7&lang=less&scoped=true&"
import style1 from "./RelevanceTopicModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a3cf7",
  null
  
)

export default component.exports